var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegativo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29289 14.2071C7.68342 14.5976 8.31658 14.5976 8.70711 14.2071L15.0711 7.84315C15.4616 7.45262 15.4616 6.81946 15.0711 6.42893C14.6805 6.03841 14.0474 6.03841 13.6569 6.42893L8 12.0858L2.34315 6.42893C1.95262 6.03841 1.31946 6.03841 0.928932 6.42893C0.538408 6.81946 0.538408 7.45262 0.928932 7.84315L7.29289 14.2071ZM7 1.19249e-08L7 13.5L9 13.5L9 -1.19249e-08L7 1.19249e-08Z",
    fill: "#9F0010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativo);
export default __webpack_public_path__ + "static/media/negativo.c2d84f0a4cf6819e85980ea9bef5be71.svg";
export { ForwardRef as ReactComponent };